import { useCurrency } from "./CurrencyContext";

export const useCurrencyConverter = () => {
  const { currency, rates } = useCurrency();

  const convert = (amountInPKR) => {
    const exchangeRate = rates[currency] || 1;
    return (amountInPKR * exchangeRate).toFixed(2);
  };

  return convert;
};
